import { Grid, IconButton, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'
import {
  MdAdd,
  MdArrowBack,
  MdOutlineDoneOutline,
  MdOutlineExitToApp,
} from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'

const AutorizacaoDeAcesso = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(false)

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
    setRefresh((v) => !v)
  }

  const autorizar = (acesso) => async (e) => {
    e.stopPropagation()
    await metodoPrograma('autorizaAcesso', {
      idAutorizacaoAcesso: acesso[0],
    })
    return setRefresh((v) => !v)
  }

  const registrarSaida = (acesso) => async (e) => {
    e.stopPropagation()
    await metodoPrograma('salvaSaida', {
      idAutorizacaoAcesso: acesso[0],
    })
    return setRefresh((v) => !v)
  }

  const handleClick = (v) => {
    setDados(v)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela])

  return (
    <Programa codigo="CtrlAutorizacaoAcesso" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlAutorizacaoAcesso"
              action="lista"
              rows={10}
              onRowSelect={handleClick}
              habSearch={true}
              refresh={refresh}
              head={['Nome', 'Entrada', 'Saida', 'Motivo', 'Entrou', 'Saiu']}
              collumnsDateHour={[1, 2]}
              line={(item) => [item[1], item[2], item[3], item[4], '', '']}
              columnOptions={[
                {
                  alias: 4,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton
                      size="small"
                      onClick={autorizar(linhaOriginal)}
                      style={
                        linhaOriginal[2]
                          ? { color: 'green' }
                          : { color: 'orange' }
                      }
                    >
                      <MdOutlineDoneOutline />
                    </IconButton>
                  ),
                },
                {
                  alias: 5,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton
                      size="small"
                      style={
                        linhaOriginal?.[3]
                          ? { color: 'green' }
                          : { color: 'orange' }
                      }
                      onClick={registrarSaida(linhaOriginal)}
                    >
                      <MdOutlineExitToApp />
                    </IconButton>
                  ),
                },
              ]}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela }} />
      )}
    </Programa>
  )
}

export default AutorizacaoDeAcesso
